



















































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {mixins} from 'vue-class-component'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {Faktura, PodesavanjeSistema, StavkaDokumenta} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {formatPrice} from "@/utils/formatters";
import * as _ from 'lodash';
import {focusCena} from "@/utils/focusFunctions";
import StavkeFaktureBezRadnogNaloga
    from "@/views/Odrzavanje/Dokumenta/Faktura/ServisnaFaktura/StavkeServisneFakture.vue";
import ServisneOperacijeFaktureBezRadnogNaloga
    from "@/views/Odrzavanje/Dokumenta/Faktura/ServisnaFaktura/ServisneOperacijeServisneFakture.vue";
import {State} from "vuex-class";

@Component({
    components: {
        'mf-stavke-fakture': StavkeFaktureBezRadnogNaloga,
        'mf-servisne-operacije-fakture': ServisneOperacijeFaktureBezRadnogNaloga
    }
})
export default class FakturaBezRadnogNaloga extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @State podesavanjeSistema: PodesavanjeSistema;

    faktura: Faktura = null;

    stete = [];
    total = 0;
    isBusy = false;

    created() {
        this.kreirajNovu();
    }

    async inputBrojDokumenta(id) {
        if (id) {
            const faktura = await this.loadData(() => dataProxy.vratiFakturuPoId(id))();
            if (!faktura) {
                this.showInfo('nije moguce ucitati dokument')
            } else {
                this.faktura = faktura;
            }
        }
    }

    async sacuvajFakturu() {
        if (this.isBusy) return;
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            this.faktura.servisneOperacije =
                this.faktura.servisneOperacije.filter(x => x.cena && x.kolicina);

            this.faktura.fakturisaniDelovi =
                this.faktura.fakturisaniDelovi.filter(x => x.opis && x.kolicina && x.cena);
            this.isBusy = true;
            try {
                this.faktura = await this.saveData(() => dataProxy.sacuvajFakturu(this.faktura))();
            } finally {
                this.isBusy = false;
            }
        } else {
            this.showError('nisu sva obavezna polja popunjena');
        }
    }

    async zakljuciDokument() {
        if (this.isBusy) return;
        const valid = await (<any>this.$refs.observer).validate();
        if (!valid) {
            this.showError('nisu sva obavezna polja popunjena');
            return;
        }
        /*if (this.total != this.ukupno) {
            this.showError('ukupan iznos se ne slaze');
            return;
        }*/
        this.faktura.servisneOperacije =
            this.faktura.servisneOperacije.filter(x => x.cena && x.kolicina);
        this.faktura.fakturisaniDelovi =
            this.faktura.fakturisaniDelovi.filter(x => x.opis && x.kolicina && x.cena);
        try {
            this.isBusy = true;
            await this.saveData(() => dataProxy.zakljuciFakturu(this.faktura))();
            this.kreirajNovu();
        } finally {
            this.isBusy = false;
        }

    }

    kreirajNovu() {
        this.faktura = Faktura.fromJS({
            datum: new Date(),
            servisneOperacije: [],
            fakturisaniDelovi: [],
            sopstveniDelovi: []
        });
        this.total = 0;
    }

    get uslugeUkupno() {
        return _.sumBy(this.faktura.servisneOperacije, s => s.osnovica || 0);
    }

    get deloviUkupno() {
        return _.sumBy(this.faktura.fakturisaniDelovi, s => s.osnovica || 0);
    }

    get ukupno() {
        return this.uslugeUkupno + this.deloviUkupno;
    }

    get pdv() {
        return _.sumBy(this.faktura.fakturisaniDelovi, s => (s.osnovica || 0) * (s.pdvStopa || 0) / 100) +
               _.sumBy(this.faktura.servisneOperacije, s => (s.osnovica || 0) * (s.pdvStopa || 0) / 100);
    }

    get ukupnoSaPdv() {
        return this.ukupno + this.pdv;
    }

    async obrisanaStavka(stavka: StavkaDokumenta) {
        this.faktura.fakturisaniDelovi = this.faktura.fakturisaniDelovi.filter(x => x != stavka);
        this.faktura.servisneOperacije = this.faktura.servisneOperacije.filter(x => x != stavka);
    }

    async obrisanaServisnaOperacija(servisnaOperacije: StavkaDokumenta) {
        this.faktura.servisneOperacije = this.faktura.servisneOperacije.filter(x => x != servisnaOperacije);
        if (servisnaOperacije.id) {
            await this.deleteData(() => dataProxy.obrisiStavkuDokumenta(servisnaOperacije.id))();
        }
    }

    @Watch('faktura.voziloId') async onVoziloChanged(v) {
        if (v) {
            const stete = await dataProxy.vratiStetneDogadjajeVozila(v);
            this.stete = stete.map(steta => ({id: steta.brojSteteSaZapisnika, text: steta.brojSteteSaZapisnika}));
            this.stete.unshift({id: '', text: '...'});
        }

    }
}
